export default {
  actions: {
    falconEventHandler({ rootState, dispatch }, { name, data }) {
      switch (name) {
        case 'new-call-receive': {
          const { user_info } = rootState.auth
          const { real_session_id = null, project_id = null } = data
          if (real_session_id && user_info?.project_id && user_info.project_id === project_id) {
            dispatch('fetchVideoList', { mode: 'banner', id: real_session_id })
          }
          break
        }

        case 'refresh-call-list': {
          dispatch('fetchVideoList', { mode: 'refresh' })
          break
        }

        case 'refresh-live-chat-list': {
          dispatch('fetchChatList', { from: 'Falcon' })
          break
        }

        case 'refresh-live-chat-message': {
          const { session_id = null } = data
          dispatch('fetchChatMessage', { from: 'Falcon', session_id: session_id })
          break
        }

        default:
          console.log('unhandled event received - ', name)
      }
    }
  }
}
